<template>
  <base-card class="px-lg-3">
    <div class="px-lg-2 py-1">
      <base-heading class="title-card">
        Your Team's Campaign Performance
      </base-heading>
      <template v-if="loading">
        <base-skeleton class="w-100 d-flex justify-content-between">
          <div
            v-for="n in 3"
            :key="n"
            class="d-flex justify-content-between pt-5 text-center"
          >
            <div class="mt-3">
              <div
                class="skeleton__item ml-auto mr-auto"
                style="max-width: 25px"
              />
              <div
                class="skeleton__item mb-3"
                style="height:140px; width: 100px"
              />
              <div
                class="skeleton__item ml-auto mr-auto"
                style="max-width: 60%"
              />
              <div
                class="skeleton__item ml-auto mr-auto"
                style="max-width: 80%"
              />
            </div>
          </div>
        </base-skeleton>
      </template>
      <template v-else>
        <sales-summary-chart
          class="chart mt-n3 mx-n3"
          :chartdata="chartData"
          :labels="labels"
          :height="306"
          title=""
          :label-size="responsiveLabelSize"
          style="margin-top: 10px"
        />
      </template>
    </div>
  </base-card>
</template>
<script>
import SalesSummaryChart from '@/components/Widgets/Reports/SalesSummaryChart';

export default {
  name: 'AdminTeamPerformanceChartContainer',
  components: {
    SalesSummaryChart,
  },
  props: {
    dataRange: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      responsiveLabelSize: 10,
    };
  },
  computed: {
    chartData() {
      return [{
        name: 'Open Rate',
        values: this.chartValues.map((value) => (this.getRate(value))),
      }];
    },
    chartValues() {
      return [this.stats.open_rate_range, this.stats.click_rate_range, this.stats.unsubscribe_rate_range];
    },
    labels() {
      return [
        ['Average', 'Open Rate'],
        ['Average', 'Click-Through Rate'],
        ['Average', 'Unsub. Rate'],
      ];
    },
    stats() {
      if (!this.$store.state.institutions.item) {
        return {};
      }
      return this.$store.state.institutions.item;
    },
    loading() {
      return this.$store.state.institutions.isLoading;
    },
  },
  mounted() {
    this.mediaQuery();
  },
  methods: {
    mediaQuery() {
      /* This method mimics CSS mediaqueries but in JS.
      Required to pass variables to ChartJS */

      const mediaQuery = window.matchMedia('(min-width: 1000px)');
      const sizes = {
        small: 12, // This is an arbitrary size that fixes into ipad size
        regular: 15, // Defined by design team
      };
      const resize = (mq) => {
        this.responsiveLabelSize = (mq.matches) ? sizes.regular : sizes.small;
      };
      resize(mediaQuery); // Initial call
      mediaQuery.addEventListener('change', (mq) => resize(mq)); // Listening to changes
    },
    getRate(rate) {
      return rate > 0 ? rate : 0;
    },
  },
};
</script>
<style lang="scss"
  scoped>
::v-deep .chart.sl-card {
  .card-body {
    padding: 0;
  }
}
.title-card {
  font-family: 'Tiempos Headline';
  font-weight: 600;
  font-size: 19px;
  line-height: 120%;
  letter-spacing: 0.01em;
  color: #1B1B1B;
  margin-bottom: unset;
}

::v-deep .card-body{
  padding: 20px 20px 0px 20px !important;
}
</style>
